__turbopack_context__.v({
  "compact": "ExpandableTweetPreview-module__9t2Xka__compact",
  "expanded": "ExpandableTweetPreview-module__9t2Xka__expanded",
  "fade": "ExpandableTweetPreview-module__9t2Xka__fade",
  "measure": "ExpandableTweetPreview-module__9t2Xka__measure",
  "root": "ExpandableTweetPreview-module__9t2Xka__root",
  "toggle": "ExpandableTweetPreview-module__9t2Xka__toggle",
});
